<template>
  <form id="sms-form">
    <label class="landing-label">
      <span class="label-title">{{ $t('pages.login.sendSmsCode') }}</span>
      <input type="text"
             inputmode="numeric"
             autocomplete="one-time-code"
             :placeholder="$t('pages.login.smsCodeHere')"
             v-model.trim="smsCode"
             ref="smsLoginInput"
             @keydown.enter.prevent="handleLogin"
      >
      <small v-if="user.validation_errors.code">{{ user.validation_errors.code[0] }}</small>
    </label>

    <div v-if="countdown > 0" class="countdown-message">
      <small>{{ $t('pages.login.resendCountdown', { time: formattedCountdown }) }}</small>
    </div>

    <fieldset class="buttons">
      <button type="button"
              class="main-btn resend-btn phone-number"
              :class="{ 'disabled': isResendDisabled }"
              :disabled="isResendDisabled"
              @click="resendSmsCode"
      >
        <span class="spinner-label">{{ $t('pages.login.buttons.resend') }}</span>
      </button>
      <button type="button"
              class="main-btn submit-btn phone-number"
              @click="handleLogin"
      >
        <span class="spinner-label">{{ $t('pages.login.buttons.submit') }}</span>
      </button>
    </fieldset>
  </form>
</template>

<script>
import SmsForm from './SmsForm';
export default SmsForm;
</script>

<style scoped>
.countdown-message {
  margin-bottom: 15px;
}

.countdown-message small {
  color: #666;
  font-size: 14px;
}

#sms-form .buttons {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

/* Increase specificity naturally instead of !important */
#sms-form .buttons .resend-btn {
  float: none;
  margin-right: 0;
}

#sms-form .buttons .submit-btn {
  float: none;
}

#sms-form .buttons .resend-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #999;
  pointer-events: none;
}

#sms-form .buttons .resend-btn.disabled:hover {
  cursor: not-allowed;
  background-color: #999;
}
</style>
